<!--============================
=            CHART6            =
=============================-->

<template>
  <div>
    <div justify center>
      <div id="chart-pie"></div>
      <div style="height:25px"></div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    // Create the chart
    var options = {
      chart: {
        height: 350,
        type: "radialBar",
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        radialBar: {
          startAngle: -135,
          endAngle: 225,
          hollow: {
            margin: 15,
            size: "70%",

            imageWidth: 64,
            imageHeight: 64,
            imageClipped: false
          },
          track: {
            background: "#fff",
            strokeWidth: "67%",
            margin: 0, // margin is in pixels
            dropShadow: {
              enabled: true,
              top: -3,
              left: 0,
              blur: 4,
              opacity: 0.35
            }
          },

          dataLabels: {
            showOn: "always",
            name: {
              offsetY: -10,
              show: true,
              color: "#888",
              fontSize: "17px"
            },
            value: {
              formatter: function(val) {
                return parseInt(val);
              },
              color: "#111",
              fontSize: "36px",
              show: true
            }
          }
        }
      },
      colors: ["#845EC2", "#A178DF", "#BE93FD", "#DCB0FF"],
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "horizontal",
          shadeIntensity: 0.5,
          gradientToColors: ["#845EC2"],
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100]
        }
      },
      series: [75],
      stroke: {
        lineCap: "round"
      },
      labels: ["CO2"]
    };

    var chart = new ApexCharts(document.querySelector("#chart-pie"), options);

    chart.render();

    //////////////////////////////////////////////////////////////////////////////////////
  }
};
</script>


<!--====  End of CHART6  ====-->